import { IPageTabNavLink } from "../interfaces-and-types";

export const teamsecurityLink: IPageTabNavLink[] = [
    {
        name: 'Team & Security',
        route: '',
    },
]